<template>
  <a-drawer width="35%" :label-col="4" :wrapper-col="14" :visible="open" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :model="form" :rules="rules">
      <a-form-model-item label="消息类型,1-点赞,2-转发,3-评论,4-回复,5-at,6-关注" prop="type" >
      </a-form-model-item>
      <a-form-model-item label="作品id,外键{zb_works.id}" prop="worksId" >
        <a-input v-model="form.worksId" placeholder="请输入作品id,外键{zb_works.id}" />
      </a-form-model-item>
      <a-form-model-item label="操作用户id,外键{zb_user.id}" prop="operateUserId" >
        <a-input v-model="form.operateUserId" placeholder="请输入操作用户id,外键{zb_user.id}" />
      </a-form-model-item>
      <a-form-model-item label="评论或回复内容" prop="content" >
        <editor v-model="form.content" />
      </a-form-model-item>
      <a-form-model-item label="是否已读,0-未读,1-已读" prop="read" >
        <a-input v-model="form.read" placeholder="请输入是否已读,0-未读,1-已读" />
      </a-form-model-item>
      <a-form-model-item label="用户id,外键{zb_user.id}" prop="userId" >
        <a-input v-model="form.userId" placeholder="请输入用户id,外键{zb_user.id}" />
      </a-form-model-item>
      <a-form-model-item label="备注" prop="remark" >
        <a-input v-model="form.remark" placeholder="请输入内容" type="textarea" allow-clear />
      </a-form-model-item>
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            保存
          </a-button>
          <a-button type="dashed" @click="cancel">
            取消
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
import { getNotice, addNotice, updateNotice } from '@/api/message/notice'
import Editor from '@/components/Editor'

export default {
  name: 'CreateForm',
  props: {
  },
  components: {
    Editor
  },
  data () {
    return {
      submitLoading: false,
      formTitle: '',
      // 表单参数
      form: {
        id: null,

        type: null,

        worksId: null,

        operateUserId: null,

        content: null,

        read: null,

        userId: null,

        createTime: null,

        remark: null,

      },
      // 1增加,2修改
      formType: 1,
      open: false,
      rules: {
        type: [
          { required: true, message: '消息类型,1-点赞,2-转发,3-评论,4-回复,5-at,6-关注不能为空', trigger: 'change' }
        ],
        worksId: [
          { required: true, message: '作品id,外键{zb_works.id}不能为空', trigger: 'blur' }
        ],
        operateUserId: [
          { required: true, message: '操作用户id,外键{zb_user.id}不能为空', trigger: 'blur' }
        ],
        content: [
          { required: true, message: '评论或回复内容不能为空', trigger: 'blur' }
        ],
        read: [
          { required: true, message: '是否已读,0-未读,1-已读不能为空', trigger: 'blur' }
        ],
        userId: [
          { required: true, message: '用户id,外键{zb_user.id}不能为空', trigger: 'blur' }
        ]
      }
    }
  },
  filters: {
  },
  created () {
  },
  computed: {
  },
  watch: {
  },
  mounted () {
  },
  methods: {
    onClose () {
      this.open = false
    },
    // 取消按钮
    cancel () {
      this.open = false
      this.reset()
    },
    // 表单重置
    reset () {
      this.formType = 1
      this.form = {
        id: null,
        type: null,
        worksId: null,
        operateUserId: null,
        content: null,
        read: null,
        userId: null,
        createTime: null,
        remark: null,
      }
      this.$nextTick(() => {
        if(this.$refs.form){
          this.$refs.form.resetFields()
        }
      })
    },
    /** 新增按钮操作 */
    handleAdd (row) {
      this.reset()
      this.formType = 1
      this.open = true
      this.formTitle = '添加'
    },
    /** 修改按钮操作 */
    handleUpdate (row, ids) {
      this.reset()
      this.formType = 2
      const id = row ? row.id : ids
      getNotice({"id":id}).then(response => {
        this.form = response.data
        this.open = true
        this.formTitle = '修改'
      })
    },
    /** 提交按钮 */
    submitForm: function () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          if (this.form.id !== undefined && this.form.id !== null) {
            updateNotice(this.form).then(response => {
              this.$message.success(
                '修改成功',
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          } else {
            addNotice(this.form).then(response => {
              this.$message.success(
                '新增成功',
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          }
        } else {
          return false
        }
      })
    }
  }
}
</script>
